import type { ReactNode } from "react";

import { Card } from "@/design-system/Card";
import type { DesignSystemElementProps, DesignSystemRef } from "@/design-system/contracts/dom";
import { Inline } from "@/design-system/Inline";
import { Stack } from "@/design-system/Stack";
import { Text } from "@/design-system/Text";

export type CardActionPromptProps = {
  action: ReactNode;
  children: ReactNode;
} & DesignSystemElementProps<"div"> &
  DesignSystemRef<HTMLDivElement>;

/** A centered card action followed by a compact run of supporting caption lines. */
export function CardActionPrompt({ action, children, ref, ...nativeProps }: CardActionPromptProps): ReactNode {
  return (
    <Card {...nativeProps} ref={ref}>
      <Inline justify="center">{action}</Inline>
      <Stack gap="xs">{children}</Stack>
    </Card>
  );
}

export type CardActionPromptDescriptionProps = {
  children: ReactNode;
} & DesignSystemElementProps<"span"> &
  DesignSystemRef<HTMLSpanElement>;

export function CardActionPromptDescription({
  children,
  ref,
  ...nativeProps
}: CardActionPromptDescriptionProps): ReactNode {
  return (
    <Text {...nativeProps} ref={ref} variant="caption" align="center" overflow="normal">
      {children}
    </Text>
  );
}
